/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { Container, StyledOption } from "./styles";

const SelectCitie = ({ id, options, value, onChange}) => {
    const { t } = useTranslation();
    return(
        <Container id={id} value={value ? value : options[0]} onChange={onChange}>
            {options ? options.map((option, index) => (
                <StyledOption key={index} value={option.code_ibge} disabled={option === t("select.city")}>
                    {option.name}
                </StyledOption>
            )) : <></>}
        </Container>
    )
}

export default SelectCitie;
